import { createContext, useContext, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import LeadForm from '@/components/shared/LeadForm';

const PopupContext = createContext();

export const usePopup = () => useContext(PopupContext);

export function PopupProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [packageInfo, setPackageInfo] = useState(null);

  const openPopup = (pkg = null) => {
    setPackageInfo(pkg);
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    setPackageInfo(null);
  };

  return (
    <PopupContext.Provider value={{ isOpen, openPopup, closePopup, packageInfo }}>
      {children}
      <Dialog open={isOpen} onOpenChange={(open) => { if (!open) closePopup(); }}>
        <DialogContent className="sm:max-w-[500px] p-0 overflow-hidden" data-testid="universal-popup">
          <div className="bg-[#064E3B] px-6 py-5">
            <DialogHeader>
              <DialogTitle className="text-white font-heading text-xl">Secure Your Brand Identity</DialogTitle>
              <DialogDescription className="text-emerald-200 text-sm">
                Fill in your details and our trademark specialists will reach out to you shortly.
              </DialogDescription>
            </DialogHeader>
          </div>
          <div className="p-6">
            <LeadForm
              packageTitle={packageInfo?.title || 'Essentials'}
              packageAmount={packageInfo?.amount || 45}
              tmSignUpType={packageInfo?.tmSignUpType || 1}
              onSuccess={closePopup}
            />
          </div>
        </DialogContent>
      </Dialog>
    </PopupContext.Provider>
  );
}
